
/**
 * https://www.hl7.org/fhir/references.html
 * 
 * References are always defined and represented in one particular direction - 
 * from one resource (source) to another (target). References are either provided as a 
 * literal URL, which may either be absolute or relative, or as a logical identifier. 
 * 
 * Resources contain two types of references:
 * 
 * - Internal "contained" references - references to other resources packaged inside the source resource
 * - External references - references to resources found elsewhere
 * 
 * At least one of reference, identifier and display SHALL be present (unless an extension is provided).
 *
 */ 

function Reference () {
    this.reference  = null;
    this.display    = '';
    this.identifier = null;
}


/**
 * Set literal reference like: 
 * - an absolute URL (to resource)
 * - a relative URL, which is relative to the Service Base URL, or, in a bundle, 
 *   the Bundle.entry.fullUrl (see Resolving References in Bundles)
 * - an internal fragment reference "Contained Resources"
 * 
 * @param String url Referenced full uri, relative, or contained
 * @param String display Human readable resource name?
 */
Reference.prototype.setLiteralReference = function( url, display ) {
  
  if( display ){
    this.display = display;
  }

  this.reference = url;
};


export default Reference;
